import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/dashboard`;

class DashboardServices {
  async getStats() {
    try {
      const res = await requestToken.get(`${API_ROUTE}/stats`);
      return res?.data;
    } catch (error) {
      console.error("Error in getStats:", error);
      throw error;
    }
  }
}

export default new DashboardServices();
